<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">数据统计 </span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <div class="recharge-message">
      <div class="recharge-item">
        <div class="item">
          <p>今日已审</p>
          <p>{{ statisticsInfo.todayPassCount | thousands}}条</p>
        </div>
        <div class="item">
          <p>昨日审核总量</p>
          <p>{{ statisticsInfo.yesterdayPassCount | thousands}}条</p>
        </div>
        <!-- </div>
      <div class="recharge-item"> -->
        <div class="item">
          <p>审核总量</p>
          <p>{{ statisticsInfo.passCount | thousands}}条</p>
        </div>
        <div class="item">
          <p>近一周审核总量</p>
          <p>{{ statisticsInfo.weekCount | thousands}}条</p>
        </div>
        <div class="item">
          <p>近一月审核总量</p>
          <p>{{ statisticsInfo.monthsCount | thousands}}条</p>
        </div>
        <div class="item">
          <p>通过率</p>
          <p>{{ statisticsInfo.passRate }}条</p>
        </div>
      </div>
    </div>
    <div class="recharge-statistic">
      <el-card style="height:400px; width: 100%; position: relative;">
        <ul class="recharge-tabs">
          <li :class="dayType == 1 ? 'active' : ''" @click="dayType = 1">按日</li>
          <li :class="dayType == 2 ? 'active' : ''" @click="dayType = 2">按月</li>
        </ul>
        <div id="lineChart" style="width: 100%; height: 350px"></div>
      </el-card>
    </div>
    <el-card class="page-content" shadow="never">
      <el-tabs :value="activeTab">
        <el-tab-pane label="审核量数据" name="all"></el-tab-pane>
      </el-tabs>
   
      <allList></allList>
      <!-- <handleList></handleList> -->
    </el-card>
  </div>
</template>
<script>
import allList from "./allList.vue";
import handleList from "./handleList.vue";
import api from "../../api";
export default {
  components: {
    allList,
    handleList
  },
  data() {
    return {
      activeTab: "",
      dataArry: "",
      rechargeLine: null,
      rechargePie: null,

      statisticsInfo: {},
      dayType: 1, //1日  2月
      xData:[],
      yData:[],
      createByAllArr:[]
    };
  },
  created() {},
  mounted() {
    this.pageReload();
  },
  methods: {
    pageReload() {
      this.getStatisticsInfo(); //获取充值审核统计
     
    },
    drawLine() {
      let lineChart = document.getElementById("lineChart");
      this.rechargeLine = this.$echarts.init(lineChart);
      let option = {
        color: "#f9a957",
        title: {
          text: "审核量走势",
          left: "left"
        },
        tooltip: {
          trigger: "axis"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "当日审核量",
            type: "line",
            data: this.yData
          }
        ]
      };
      option && this.rechargeLine.setOption(option);
    },

    getStatisticsInfo() {
      api.getStatisticsInfo().then(res => {
        this.statisticsInfo = res.data;
      });
    },

    getStatisticsReport() {
      api
        .getStatisticsReport({
          type: this.dayType
        })
        .then(res => {
           this.xData=[];
           this.yData=[];
          res.data.forEach(item=>{
            this.xData.push(item.time);
            this.yData.push(item.count);
          })
           this.drawLine();
        });
    },

  
  },
  watch: {
    dayType: {
      handler(val, oldVal) {
        this.getStatisticsReport()
      },
      immediate: true
    }
  }
};
</script>
<style lang="less">
.recharge {
  &-statistic {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
  }
  &-tabs {
    position: absolute;
    right: 40px;
    list-style: none;
    z-index: 10;
    li {
      display: inline-block;
      cursor: pointer;
      line-height: 30px;
      width: 50px;
      float: left;
      text-align: center;
      border: 1px solid #e8e8e8;
      &:hover {
        background-color: #83dafb;
        color: #e8e8e8;
      }
      &.active {
        background-color: #409eff;
        color: #fff;
      }
    }
  }
}
</style>
